import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const TranslationsFactory =
    (http: HttpClient): TranslateHttpLoader => new TranslateHttpLoader(http);
